import { connect } from 'react-redux';

export const mapStateToModuleProps = module => ({ locale, localeData }) => ({
  locale,
  i18n: localeData[`${locale}${module.replace(/^\w/, c => c.toUpperCase())}`],
});
export const mapStateToProps = ({ locale, localeData }) => ({ locale, i18n: localeData[locale] });

export default arg => {
  if (typeof arg === 'string') {
    const module = arg;
    return component => connect(mapStateToModuleProps(module))(component);
  }

  const component = arg;
  return connect(mapStateToProps)(component);
};
